import React,{useState, useEffect} from 'react'

const useLocation = () => {
    const [countryCode, setCountryCode] = useState("in");
     useEffect(() => {
        const fetchCountry = async () => {
          try {
            const res = await fetch("https://ipapi.co/json");
            const data = await res.json();
            setCountryCode(data?.country_code?.toLowerCase() || "in");
          } catch (err) {
            console.log("Could not fetch country. Defaulting to IN");
          }
        };
        fetchCountry();
    }, []);
    return {countryCode};
}

export default useLocation